import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICCamera } from "../models/entities/iccamera";
import { ICCameraFilter } from "../models/filters/iccamera.filter";
import { ICCameraApi } from "../models/apis/iccamera.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICCameraService extends BaseDataService<
  ICCamera,
  ICCameraFilter,
  ICCameraApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICCamera);
    this.EndPoint = "iccamera";
  }
}
